import React, { useEffect, useRef } from 'react';
import { Box, Checkbox } from '@paygreen/paygreen-ui';
import { IsBigDesktop } from '../../utils/tools';

const TableCheckbox = React.forwardRef(
    ({ indeterminate, inputId, ...rest }, ref) => {
        const defaultRef = useRef();
        const resolvedRef = ref || defaultRef;

        useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return (
            <Box marginLeft={!IsBigDesktop() ? 'sm' : null}>
                <Checkbox id={inputId} inputRef={resolvedRef} {...rest} />
            </Box>
        );
    },
);

export default TableCheckbox;
